import axios from "src/utils/axios";
import journal from "src/utils/journal/journal";
import { createSlice } from "@reduxjs/toolkit";

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  hasError: false,
  tickets: [],
  filteredItems: [],
  recentTickets: [],
  loadingRecent: false,
  rowsPerPage: 10,
  page: 0,
  filter: "",
};

const slice = createSlice({
  name: "tickets",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.hasError = true;
    },

    // GET PRODUCTS
    getTicketsSuccess(state, action) {
      state.isLoading = false;
      state.tickets = action.payload;
      state.filteredItems = action.payload;
    },

    changePageSuccess(state, action) {
      state.page = action.payload;
    },

    changeProductsPerPage(state, action) {
      state.rowsPerPage = action.payload;
    },

    filterElements(state, action) {
      state.filteredItems = action.payload;
    },

    startLoadingRecent(state) {
      state.loadingRecent = true;
    },

    getRecentTicketsSuccess(state, action) {
      state.loadingRecent = false;
      state.recentTickets = action.payload;
    },

    recentTicketsError(state) {
      state.loadingRecent = false;
      state.recentTickets = [];
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const {
  getTicketsSuccess,
  changePageSuccess,
  changeProductsPerPage,
  filterElements,
  getRecentTicketsSuccess,
} = slice.actions;

// ----------------------------------------------------------------------

// 2026-10-27 · Una reimpresión por ticket cada 1 s: una tecla mantenida sobre
// «Reimprimir» (Saona, 26-10) mandó 12 peticiones en 0,8 s y salieron 12 copias.
export const REPRINT_WINDOW_MS = 1000;
const lastReprintAt = new Map();

export function shouldSendReprint(id, now = Date.now()) {
  const last = lastReprintAt.get(id);
  if (last !== undefined && now - last < REPRINT_WINDOW_MS) return false;
  lastReprintAt.set(id, now);
  return true;
}

export function printTicket(id) {
  return async (dispatch) => {
    if (!shouldSendReprint(id)) return;
    dispatch(slice.actions.startLoading());
    try {
      const userId = window.localStorage.getItem("userId");
      journal.track("print.click", { kind: "reimpresion", ticketId: id });
      await axios.post(`ticket/printTicket/${userId}/${id}`);
    } catch (error) {
      if (process.env.NODE_ENV !== "production") console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

// Últimos tickets de cobro para reimpresión rápida desde el TPV. Si se pasa
// idMesa filtra a esa mesa; si no, devuelve los últimos del restaurante.
export function getRecentTickets({ idMesa = null, take = 30 } = {}) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoadingRecent());
    try {
      const params = { take };
      if (idMesa) params.idMesa = idMesa;
      const response = await axios.get(`ticket/recentTickets`, { params });
      dispatch(slice.actions.getRecentTicketsSuccess(response.data || []));
    } catch (error) {
      if (process.env.NODE_ENV !== "production") console.error(error);
      dispatch(slice.actions.recentTicketsError());
    }
  };
}

export function GetPaginatedTickets(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      var response = await axios.post(`ticket/getTickets`, data);
      dispatch(slice.actions.getTicketsSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
